import { DateObjectUnits, DateTime } from "luxon"

// Based on https://github.com/amaidah/luxon-business-days/blob/master/src/index.js
export const workingDay = (start: DateTime, days: number): DateTime => {
  let date = start
  for (let businessDaysLeftToAdd = days; businessDaysLeftToAdd > 0; ) {
    date = date.plus({ days: 1 })
    if (isBusinessDay(date) && !isHoliday(date)) {
      businessDaysLeftToAdd--
    }
  }
  return date
}

const isBusinessDay = (date: DateTime) => {
  return date.weekday <= 5
}

const isNewYearsDay: HolidayFunction = (date) => date.month === 1 && date.day === 1
const isEaster: HolidayFunction = (date, easter) => {
  // Monday after Easter
  const yesterday = date.minus({ days: 1 })
  return (
    (date.month === easter.month && date.day === easter.day) ||
    (easter.month === yesterday.month && easter.day === yesterday.day)
  )
}
const isKingsDay: HolidayFunction = (date) => date.month === 4 && date.day === 27
const isAscensionDay: HolidayFunction = (date, easter) => {
  // 39nd day after Easter
  const checkDate = date.minus({ days: 39 })
  return easter.month === checkDate.month && easter.day === checkDate.day
}
const isPentecost: HolidayFunction = (date, easter) => {
  // 49th and 50th day after Easter
  const checkDate1 = date.minus({ days: 49 })
  const checkDate2 = date.minus({ days: 50 })
  return (
    (easter.month === checkDate1.month && easter.day === checkDate1.day) ||
    (easter.month === checkDate2.month && easter.day === checkDate2.day)
  )
}
const isChristmas: HolidayFunction = (date) => date.month === 12 && (date.day === 25 || date.day === 26)

/*
 * Based on
 * https://github.com/amaidah/luxon-business-days/blob/f5d875c5993d6a6b6008dc50992899eb5d7379f0/src/helpers.js
 * https://gist.github.com/johndyer/0dffbdd98c2046f41180c051f378f343
 * https://www.irt.org/articles/js052/index.htm
 */
const getEaster = (year: number): DateObjectUnits => {
  const f = Math.floor,
    // Golden Number - 1
    G = year % 19,
    C = f(year / 100),
    // related to Epact
    H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30,
    // number of days from 21 March to the Paschal full moon
    I = H - f(H / 28) * (1 - f(29 / (H + 1)) * f((21 - G) / 11)),
    // weekday for the Paschal full moon
    J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7,
    // number of days from 21 March to the Sunday on or before the Paschal full moon
    L = I - J,
    month = 3 + f((L + 40) / 44),
    day = L + 28 - 31 * f(month / 4)

  return { month, day }
}

type HolidayFunction = (date: DateTime, easter: DateObjectUnits) => boolean
const HOLIDAY_FUNCTIONS = [isNewYearsDay, isEaster, isKingsDay, isAscensionDay, isPentecost, isChristmas]

export const isHoliday = (date: DateTime) => {
  const easter = getEaster(date.year)
  return HOLIDAY_FUNCTIONS.some((func) => func(date, easter))
}
